import { getAnnotation, getTemplate } from '@/mgnl/utils/magnolia.js';
import { EditorContextService, PageEditorBridge } from '@magnolia/frontend-helpers-base';
import { defineElement, TemplateElement } from '@webtides/element-js';

class MgnlEditablePage extends TemplateElement {
    properties() {
        return {
            content: null,
            templateAnnotations: null,
            config: null,
            mgnlContext: null,
            tagName: 'fallback-component',
            environment: null,
            addPageAnnotation: true,
        };
    }

    provideProperties() {
        return {
            config: this.config,
            mgnlContext: this.mgnlContext,
            environment: this.environment,
            templateAnnotations: this.templateAnnotations,
        };
    }

    async connected() {
        if (this.mgnlContext?.isMagnoliaEdit) {
            PageEditorBridge.initialVariantsHandler({}, false);
            PageEditorBridge.init({});
        }
    }

    notify() {
        EditorContextService.refresh();
        EditorContextService.onFrameReady();
    }

    get annotation() {
        return getAnnotation(this.templateAnnotations, this.content);
    }

    renderTemplate() {
        const container = this.getRoot();

        // console.log('render', this.content);
        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }

        const fragment = document.createDocumentFragment();

        if (this.addPageAnnotation && this.annotation) {
            const comment = document.createComment(this.annotation);
            fragment.appendChild(comment);
            EditorContextService.refresh(0);
        }

        this.tagName = this.config?.componentMappings?.[getTemplate(this.content)] ?? 'fallback-component';
        // this needs to be updated!
        const element = document.createElement(this.tagName);
        element.content = this.content;
        fragment.appendChild(element);

        container.appendChild(fragment);
    }
}

defineElement('mgnl-editable-page', MgnlEditablePage);
